export const updateIntState = group => {
  return {
    type: 'UPDATE_INTEGRATION',
    group,
  };
};
